import React from 'react';

const Header: React.FC = () => {
  return (
    <React.Fragment>
      <header id="main-header" className="main-header main-header--page main-header--user">
        <div className="main-header__inner">
          <a href="/customer/sign_in" className="main-header__logo">
            <picture>
              <source srcSet={`${process.env.PUBLIC_URL}/img/webp/common/logo-white-sp.webp`} media="(max-width:834px)" type="image/webp" />
              <source srcSet={`${process.env.PUBLIC_URL}/img/common/logo-white-sp.png`} media="(max-width:834px)" />
              <source srcSet={`${process.env.PUBLIC_URL}/img/webp/common/logo-white.webp`} type="image/webp" />
              <img src={`${process.env.PUBLIC_URL}/img/common/logo-white.png`} alt="SEED" />
            </picture>
          </a>
        </div>
      </header>
    </React.Fragment>
  )
}

export default Header;